import React, { useState } from "react"
import { useHistory } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons"
import * as Addons from "../../utilities/Addons"
import CustomModal from "../basics/interface/CustomModal"
import Loader from "../basics/Loader"
import { COLORS } from "../../utilities/Constants"
import { generalStyles } from "../styles/styles"
import { tableStyles } from "../styles/tableStyles"

// Version V2 (CustomModal) de AtelierModeleModal — liste des modèles de fiche
// (filtrés par svp) ; double-clic pour appliquer le modèle. Props identiques.
const AtelierModeleModalV2 = ({
	closeModal,
	listeAtelierModeles,
	fetchAtelierModeles,
	addModeleToAtelier,
	isSVP,
}) => {
	const history = useHistory()
	const [hover, setHover] = useState(null)
	const applyModele = (modele) => {
		addModeleToAtelier(modele)
		closeModal()
	}
	const rows = listeAtelierModeles.filter((a) => a.svp === isSVP)
	return (
		<CustomModal title={"Modèles"} onClose={closeModal} showFooter={false}>
			{fetchAtelierModeles.loading ? (
				<Loader size={28} padding={24} message="Chargement…" />
			) : (
				<div style={tableStyles.container}>
					<table style={tableStyles.table}>
						<thead>
							<tr>
								<th style={tableStyles.th}>Nom</th>
								<th style={tableStyles.thRight}>Tarif</th>
								<th style={{ ...tableStyles.thRight, width: 60 }} />
							</tr>
						</thead>
						<tbody>
							{rows.length === 0 ? (
								<tr>
									<td colSpan={3} style={tableStyles.empty}>
										Aucun modèle.
									</td>
								</tr>
							) : (
								rows.map((modele, i) => (
									<tr
										key={modele.id}
										onDoubleClick={() => applyModele(modele)}
										onMouseEnter={() => setHover(modele.id)}
										onMouseLeave={() => setHover(null)}
										style={{
											cursor: "pointer",
											backgroundColor:
												hover === modele.id
													? COLORS.accentLight
													: tableStyles.rowBg(i),
										}}
									>
										<td
											style={{
												...tableStyles.td,
												fontWeight: 500,
												textAlign: "left",
											}}
										>
											{modele.nom}
										</td>
										<td style={tableStyles.tdRight}>
											{Addons.round100(modele.total)}
										</td>
										<td style={tableStyles.tdRight}>
											<button
												type="button"
												title="Ouvrir le modèle"
												onClick={(e) => {
													e.stopPropagation()
													history.push(
														`/atelier/modeles/${modele.id}`,
													)
												}}
												style={generalStyles.iconBtn(COLORS.accent)}
											>
												<FontAwesomeIcon icon={faExternalLinkAlt} />
											</button>
										</td>
									</tr>
								))
							)}
						</tbody>
					</table>
				</div>
			)}
			{!fetchAtelierModeles.loading && (
				<div style={{ color: COLORS.textMuted, fontSize: 12, marginTop: 8 }}>
					Double-cliquez sur un modèle pour l'appliquer.
				</div>
			)}
		</CustomModal>
	)
}

export default AtelierModeleModalV2
